<template>
  <b-list-group-item :class="[this.active ? 'active' : null]">
    <b-row @click="$emit('selectTestPackage', testPackage)">
      <!--      <b-col md="1">-->
      <!--        <i v-if="this.active === true" class="fal fa-toggle-on font-3xl text-success" @click="$emit('selectTestPackage')"></i>-->
      <!--        <i v-else class="fal fa-toggle-off font-3xl" @click="$emit('selectTestPackage', testPackage)"></i>-->
      <!--      </b-col>-->
      <b-col md="10">
        <div class="h5">{{ testPackage.name }}</div>
        <template v-if="testPackage.getTestPackageSamples()">
          <div
            v-for="(testPackageSample,
            index) in testPackage.getTestPackageSamples().models"
            :key="index"
          >
            <submission-sample-analytes
              :testPackageSample="testPackageSample"
            ></submission-sample-analytes>
          </div>
        </template>
      </b-col>
      <b-col md="2" class="text-right">
        <span class="text-muted h5">{{
          "$" + parseFloat(testPackage.cost).toFixed(2)
        }}</span>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import SubmissionSampleAnalytes from "./SubmissionSampleAnalytes";

export default {
  name: "SubmissionTestPackageItem",
  components: { SubmissionSampleAnalytes },
  props: {
    testPackage: {
      type: Object,
      default: () => null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  mounted() {}
};
</script>
<style>
.list-group-item:hover {
  color: #fff;
  background-color: #20a8d8;
  border-color: #20a8d8;
  cursor: pointer;
  cursor: hand;
}
.list-group-item:hover .text-muted,
.list-group-item.active .text-muted {
  color: #fff !important;
}
</style>
